import {navigationDrawerStyles} from "@insite/content-library/Components/NavigationDrawer";
import { black } from "color-name";
import {css} from "styled-components"

navigationDrawerStyles.menuTriggerButton = {
    activeStyle: {
        backgroundColor: "transparent",
    },
    hoverStyle: {
        backgroundColor: "transparent"
    },
    css: css`
        color: black;
        background-color: transparent;
        border: none;
        
        > span {
            color: black !important;
        }
`};